export const metaRatingUpgradeFormatter = (value?: number) => {
  if (value == undefined) {
    return "";
  }
  if (value === 0) {
    return "";
  }
  const formatted = value.toFixed(1);
  return formatted === "0.0" ? "" : formatted;
};
